import { Component, OnInit, ViewChild } from '@angular/core';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { ReponseCoordonneesCredit } from 'src/app/api/model/reponse-coordonnees-credit.model';
import { FormGroup } from '@angular/forms';
import { FormulaireFiservBuilder } from 'src/app/models/formulaire/formulaire-fiserv-builder.model';
import { AccessibiliteService } from 'src/app/services/accessibilite.service';
import { NavigationService } from 'src/app/services/navigation/navigation.service';
import { ParticulierCredit } from '../../../api/model/particulier-credit.model';
import { AdressePhysiqueCredit } from 'src/app/api/model/adresse-physique-credit.model';
import { FormulaireFiserv } from '../../../models/formulaire/formulaire-fiserv.model';
import { ReponseCoordonneesCreditService } from '../../../services/reponse-coordonnees-credit/reponse-coordonnees-credit.service';
import { FormulaireFiservService } from '../../../services/formulaire-fiserv/formulaire-fiserv.service';
import { Anys } from '../../../util/anys';
import { GlobalStoreService } from 'src/app/services/global-store/global-store.service';
import { CybermetrieEnum } from '../../../models/cybermetrie/cybermetrie.enum';
import { CybermetrieCoordonneesService } from '../../../services/cybermetrie/cybermetrie.service';
import { GabaritService } from '../../../services/gabarit/gabarit.service';
import { DsdForm } from '@dsd/library-angular/dist';
import { DsdFormSummaryError } from '@dsd/library/dist/types/components/form-error-summary/form-error-summary.model';

@Component({
  selector: 'app-modifier-fiserv',
  templateUrl: './modifier-fiserv.component.html',
  standalone: false,
})
export class ModifierFiservComponent implements OnInit {
  @ViewChild(DsdForm) dsdForm: DsdForm;
  titre: string;
  isAppMobile: boolean;
  coordonneesCredit: ReponseCoordonneesCredit;
  adresseCourante: AdressePhysiqueCredit;
  particuliersCreditPlusQueUn: boolean = false;
  doitAfficherUneAdresseCourriel: boolean = false;
  formFiserv: FormGroup<FormulaireFiserv>;

  constructor(
    private readonly gestionTitreService: GestionTitreService,
    private readonly accessibiliteService: AccessibiliteService,
    private readonly navigationService: NavigationService,
    private readonly gabaritService: GabaritService,
    private readonly reponseCoordonneesCreditService: ReponseCoordonneesCreditService,
    private readonly formulaireFiservService: FormulaireFiservService,
    private readonly globalStoreService: GlobalStoreService,
    private readonly cybermetrieService: CybermetrieCoordonneesService
  ) {}

  ngOnInit(): void {
    this.coordonneesCredit = this.reponseCoordonneesCreditService.getReponseCoordonneesCredit();
    this.isAppMobile = this.gabaritService.isAppMobile();
    this.cybermetrieService.envoyerEvenementPersonnalise(
      CybermetrieEnum.CATEGORIE_TRANSACTION,
      CybermetrieEnum.ACTION_DEBUTE,
      CybermetrieEnum.LABEL_INFOS_TOTAL
    );
    this.adresseCourante = this.reponseCoordonneesCreditService.getAdresseCourante();
    this.particuliersCreditPlusQueUn = this.reponseCoordonneesCreditService.estParticuliersCreditPlusQueUn();
    this.titre = this.particuliersCreditPlusQueUn ? 'caad.titreMulticarte' : 'caad.titre';
    this.gestionTitreService.addTitreOnglet(
      this.particuliersCreditPlusQueUn
        ? 'caad.titreOnglet.modifierFiserv.titreMulticarte'
        : 'caad.titreOnglet.modifierFiserv.titre'
    );
    this.doitAfficherUneAdresseCourriel = this.determinerAffichagePourAdresseCourriel(
      this.coordonneesCredit.particulierCredit
    );
    this.initialiserFormulaire();
    this.accessibiliteService.setFocus('h2');
  }

  private initialiserFormulaire(): void {
    if (Anys.notNullOrUndef(this.formulaireFiservService.getForm())) {
      this.formFiserv = this.formulaireFiservService.getForm();
    } else {
      this.formFiserv = FormulaireFiservBuilder.build();
      this.formFiserv.patchValue({
        telephone: this.reponseCoordonneesCreditService.getTelephone().numeroTelephone,
        courriel: this.doitAfficherUneAdresseCourriel ? this.reponseCoordonneesCreditService.getAdresseCourriel() : '',
      });
    }
  }

  annulerModification(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }

  async naviguerVersPageValidation(): Promise<void> {
    const erreursForm: DsdFormSummaryError[] = await this.dsdForm.validate();
    if (
      this.estAdresseValide(erreursForm) &&
      this.formFiserv.controls.telephone.valid &&
      this.formFiserv.controls.courriel.valid
    ) {
      this.formulaireFiservService.setForm(this.formFiserv);
      this.navigationService.naviguerVersValiderCredit();
    } else {
      const erreurs = new Map<string, string>();
      const texteErreurs: string[] = [];
      Object.entries(this.formFiserv.controls)
        .filter(([key, control]) => {
          const champsAdresse = ['rue', 'ville', 'province', 'codePostal', 'appartement'];
          if (champsAdresse.includes(key)) {
            return (
              this.formFiserv.controls.utiliserMemeAdresse.valid &&
              !this.formFiserv.controls.utiliserMemeAdresse.value &&
              control.invalid
            );
          }
          return control.invalid;
        })
        .forEach(([key]) => texteErreurs.push(key));

      if (erreursForm.length > 0) {
        erreursForm.forEach((erreurForm) => {
          Object.entries(erreurForm.errors)
            .filter(([key]) => {
              return key === 'province_pc_mismatch';
            })
            .forEach(() => texteErreurs.push('codePostal'));
        });
      }

      erreurs.set(CybermetrieEnum.MESSAGE_ERREUR, texteErreurs.join('|'));
      this.cybermetrieService.envoyerEvenementPersonnalise(
        CybermetrieEnum.CATEGORIE_TRANSACTION,
        CybermetrieEnum.ACTION_ERREUR_UTILISATEUR,
        CybermetrieEnum.LABEL_INFOS_TOTAL,
        null,
        null,
        erreurs
      );
    }
  }

  private estAdresseValide(erreursForm: DsdFormSummaryError[]): boolean {
    return (
      this.formFiserv.controls.utiliserMemeAdresse.value ||
      (erreursForm.length === 0 &&
        this.formFiserv.controls.rue.valid &&
        this.formFiserv.controls.ville.valid &&
        this.formFiserv.controls.province.valid &&
        this.formFiserv.controls.codePostal.valid &&
        this.formFiserv.controls.appartement.valid)
    );
  }

  private determinerAffichagePourAdresseCourriel(particuliersCredit: Array<ParticulierCredit>): boolean {
    return (
      particuliersCredit?.length === 1 ||
      particuliersCredit?.every(
        (particulier) => particulier.adresseCourriel?.indicateurAdresseCourrielIdentique === true
      )
    );
  }
}
